import React, { ReactNode } from "react"
import Navbar from "../../shared/components/navbar"
import SideBar from "../../shared/components/dashboard-sidebar"
import { SidebarProvider } from "../../shared/components/ui/sidebar"
import MobileSidebar from "../../shared/components/dashboard-sidebar/mobile-sidebar"
import { RoleGuard } from "../../shared/components/role-guard"
import { PhotosProvider } from "../../features/photos/context/photos-context"
import { AuthGuard } from "../../shared/components/auth-guard"
import { Outlet } from "react-router-dom"

/**
 * Dashboard layout — SPA architecture.
 *
 * Auth verification is handled by <AuthGuard> (client-side).
 * Region resolution is handled by <RegionGuard> in the [region] layout.
 * Role-based access control is handled by <AuthGuard> + <RoleGuard>.
 *
 * No more server-side verifySession() or Next.js redirect().
 */
function DashboardLayout({ children }: { children?: ReactNode }) {
    return (
        <AuthGuard>
            <SidebarProvider>
                <RoleGuard>
                    <PhotosProvider>
                        <SideBar />
                        <MobileSidebar />
                        <div
                            className={`relative w-full dashboard-layout outline-none focus-visible:outline-none overflow-hidden`}
                        >
                            <Navbar />
                            {children ?? <Outlet />}
                        </div>
                    </PhotosProvider>
                </RoleGuard>
            </SidebarProvider>
        </AuthGuard>
    )
}

export default DashboardLayout
